/* eslint-disable @typescript-eslint/no-explicit-any -- aligné U3151CustomerTypeListToolBar */
/* eslint-disable react-hooks/exhaustive-deps -- useMemo sur getSelectedRows() comme U3151 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import U2000ActionBtn from '../../../u2000Core/components/buttons/U2000ActionBtn';
import U2000ResponsiveToolbar from '../../../u2000Core/components/toolbar/U2000ResponsiveToolbar';
import { FaPlus, FaRegFile, FaTrashAlt } from 'react-icons/fa';

import { useU2000AuthContext } from '../../../u2000Core/context/auth/U2000UseAuthContext';
import type { U2000GridStateHandlers } from '../../../u2000Core/reducer/formReducer/U2000GridStateHandlers';
import type { U2000TableHandlers } from '../../../u2000Core/types/U2000TableHandlers';
import { NS, U3154ROLES } from '../../U3154';
import { u3154IsSystemPaymentTypeCode } from '../../U3154Service';

interface U3154PaymentTypeListToolBarProps<T extends Record<string, any>> {
  gridStateHandlers: U2000GridStateHandlers<T>;
  handlerActions?: U2000TableHandlers<T>;
}

export const U3154PaymentTypeListToolBar: React.FC<U3154PaymentTypeListToolBarProps<Record<string, any>>> = ({
  gridStateHandlers,
  handlerActions,
}) => {
  const { t } = useTranslation();
  const { hasRole } = useU2000AuthContext();

  const disableUpdateBtn = React.useMemo(() => {
    const selectedRows = gridStateHandlers.getSelectedRows();
    return selectedRows.length !== 1;
  }, [gridStateHandlers.getSelectedRows()]);

  const disableDeleteBtn = React.useMemo(() => {
    const selectedRows = gridStateHandlers.getSelectedRows();
    if (selectedRows.length === 0) return true;
    return selectedRows.some((row) => u3154IsSystemPaymentTypeCode(row.code as string | undefined));
  }, [gridStateHandlers.getSelectedRows()]);

  const actions = [
    {
      key: 'add',
      label: t('btnAdd', { ns: NS }),
      hasRole: hasRole(U3154ROLES.ADD),
      handleClick: handlerActions?.onAdd,
      icon: FaPlus,
      Component: U2000ActionBtn,
    },
    {
      key: 'modify',
      label: t('btnModify', { ns: NS }),
      hasRole: hasRole(U3154ROLES.EDIT),
      handleClick: handlerActions?.onModify,
      disabled: disableUpdateBtn,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: 'delete',
      label: t('btnDelete', { ns: NS }),
      hasRole: hasRole(U3154ROLES.DELETE),
      handleClick: handlerActions?.onDelete,
      disabled: disableDeleteBtn,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
